import { InvoicesAction, InvoicesActionType } from '../actionTypes/invoices';
import { IInvoiceListItem } from '../types';

const invoiceReducer = (
    state: Array<IInvoiceListItem> = [],
    action: InvoicesAction
) => {
    switch (action.type) {
        case InvoicesActionType.GET_INVOICES_DATA:
            return action.payload;
        default:
            return state;
    }
};

export default invoiceReducer;
